import { createContext, ReactNode, useContext, useState } from "react";
import { SaleInfoModel } from "../../infrastructure/model/SaleInfoModel";

interface AppSaleInfoContextType {
  saleInfo: SaleInfoModel[];
  setSaleInfo: React.Dispatch<React.SetStateAction<SaleInfoModel[]>>;
}

const AppSaleInfoContext = createContext<AppSaleInfoContextType | undefined>(undefined);

export const AppSaleInfoProvider = ({ children }: { children: ReactNode }) => {
  const [saleInfo, setSaleInfo] = useState<SaleInfoModel[]>([]);

  return (
    <AppSaleInfoContext.Provider value={{ saleInfo, setSaleInfo }}>{children}</AppSaleInfoContext.Provider>
  );
};

export const useSaleInfoContext = (): AppSaleInfoContextType => {
  const context = useContext(AppSaleInfoContext);
  if (!context) {
    console.error("AppSaleInfoContext must be used within an AppSaleInfoContext");
    return {} as AppSaleInfoContextType;
  }
  return context;
};
